"use client"

import { useParams } from "next/navigation"

import OverTimeSport, {
  OverTimeSportSkeleton,
} from "compositions/events/Sport/OverTimeSport"
import { LeagueSkeleton } from "compositions/events/League/League"
import EmptyContent from "compositions/events/EmptyContent/EmptyContent"
import Navbar, { NavbarSkeleton } from "compositions/events/Navbar/Navbar"
import { GameSkeleton } from "compositions/events/Game/Game"
import OvertimeUniqueEvents from "@/compositions/events/UniqueEvents/OvertimeUniqueEvents"
import OvertimeFilteredLeagues from "@/compositions/events/FilteredLeagues/OvertimeFilteredLeagues"
import { useSports } from "hooks"

export default function OvertimeSportPage() {
  const ogParams = useParams()
  const params = ogParams?.sportSlug as string

  const { sports, loading } = useSports()

  // Add initial loading state
  if (loading || typeof window === "undefined") {
    return (
      <>
        <NavbarSkeleton />
        <OverTimeSportSkeleton>
          <LeagueSkeleton />
        </OverTimeSportSkeleton>
      </>
    )
  }

  const isUnique = params === "unique"

  if (loading) {
    return (
      <>
        <NavbarSkeleton />
        <OverTimeSportSkeleton>
          {isUnique ? (
            <GameSkeleton className="first-of-type:rounded-t-md" />
          ) : (
            <LeagueSkeleton />
          )}
        </OverTimeSportSkeleton>
      </>
    )
  }

  if (!sports) {
    return <EmptyContent />
  }

  const sport = sports.find(s => s.slug.toLocaleLowerCase() === params)

  if (!sport) {
    return <EmptyContent />
  }

  const { slug, leagues } = sport

  return (
    <Navbar>
      <OverTimeSport sport={sport} isPage>
        {isUnique ? (
          <OvertimeUniqueEvents leagues={leagues} />
        ) : (
          <OvertimeFilteredLeagues sportSlug={slug} leagues={leagues} />
        )}
      </OverTimeSport>
    </Navbar>
  )
}
